export type InputPrefillKind = "unsentDraft" | "greeting" | "summary" | "none"

export const determineInputPrefillKind = (params: {
  hasUnsentDraft: boolean
  wasGreetingReceivedAtTake: boolean
  wasChatJustTaken: boolean
}): InputPrefillKind => {
  if (params.hasUnsentDraft) {
    return "unsentDraft"
  }
  if (!params.wasGreetingReceivedAtTake) {
    return "greeting"
  }
  if (params.wasChatJustTaken) {
    return "summary"
  }
  return "none"
}
